import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  atendimento: {
    fontSize: "36px",
    color: "#424242",
  },
  actions: {
    textAlign: "left",
  },
  tituloAtendimento: {
    borderBottom: "1px solid rgba(255,255,255,0.2)",
    paddingBottom: 16,
    marginBottom: 16,
    textAlign: "center",
  },
  titloCard: {
    fontWeight: "bold",
  },
});
